import type { JSX } from 'react';

import { Button, Text } from '@change/ds-core-ui/next';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';

import { DECISION_MAKER_HASH_QUERY_PARAM_NAME } from 'src/app/pages/petitionDetails/shared/constants';

import { useDecisionMakerHash } from '../hooks/decisionMakers/decisionMakerHash';
import { usePetitionDetails } from '../hooks/petitionDetails';
import { usePetitionSignatureCount } from '../hooks/petitionStats';

type Props = {
	hideHeading?: boolean;
};

export function RespondContainerSunrise({ hideHeading }: Props): JSX.Element {
	const { slug, user } = usePetitionDetails();
	const { signatureCount } = usePetitionSignatureCount();
	const decisionMakerHash = useDecisionMakerHash();
	const responseUrl = decisionMakerHash
		? `/p/${slug}/responses/new?${DECISION_MAKER_HASH_QUERY_PARAM_NAME}=${decisionMakerHash}`
		: `/p/${slug}/responses/new`;

	return (
		<div>
			{!hideHeading && (
				<Text variant="heading" as="h2" size="x-small" className="mb-2">
					<Translate
						value="fe.components.petition_decision_maker_respond.you_are_decision_maker"
						replacements={{ starter_name: user.firstName }}
					/>
				</Text>
			)}
			<Text as="div" size="small" className="text-typography-weak mb-4">
				<TranslatePlural
					value="fe.components.petition_decision_maker_respond.you_can_respond"
					count={signatureCount.displayed}
					replacements={{ signature_count: signatureCount.displayedLocalized }}
				/>
			</Text>
			<Button
				as="a"
				variant="primary"
				href={responseUrl}
				className="mb-4 w-full"
				data-testid="dm-respond-cta-link"
				data-qa="dm-respond-cta-link"
			>
				<Translate value="fe.components.petition_decision_maker_respond.action" />
			</Button>
			<Text size="x-small" className="text-typography-weak">
				<Translate value="fe.components.petition_decision_maker_respond.disclaimer" />
			</Text>
		</div>
	);
}
